const pageWorkflow = {
    version: {
        title: 'Online History',
        backPresentVersion: 'back present version',
    }
}

export default pageWorkflow
